<template>
  <textarea
    :value="value"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    :required="required"
    :rows="rows"
    :style="{ 'resize': resize ? '' : 'none' }"
    :resize="resize"
    :maxlength="maxlength"
    @input="onInput"
    @blur="$emit('blur')"
  >
  </textarea>
</template>
<script>
export default {
  name: 'TextareaTemplate',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: String,
      default: '5',
    },
    resize: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
  },
};
</script>
